import React from 'react'
import { useTranslation } from 'react-i18next'
import { Block, ExternalLink, Heading } from 'suomifi-ui-components'
import LocalizedString, {
  LocalizedParagraphs,
} from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import {
  StyledLinkList,
  StyledLinkListItem,
} from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/GiveFeedbackInfo.sc'

const GiveFeedbackInfo = (): React.JSX.Element => {
  const { t } = useTranslation()

  return (
    <Block variant="section">
      <Heading variant="h3" id="aet-give-feedback-heading">
        <LocalizedString stringKey="aetGiveFeedbackTitle" />
      </Heading>
      <LocalizedParagraphs stringKey="aetGiveFeedbackDescription_paragraphs" />
      <StyledLinkList ariaLabelledBy="aet-give-feedback-heading">
        <StyledLinkListItem>
          <ExternalLink
            href="https://laatutyokalut.suomi.fi/p/nL4p"
            labelNewWindow={t('opensInNewWindow')}
            toNewWindow
          >
            <LocalizedString stringKey="aetGiveFeedbackAnonymousLinkName" />
          </ExternalLink>
        </StyledLinkListItem>
      </StyledLinkList>
    </Block>
  )
}

export default GiveFeedbackInfo
